// extracted by mini-css-extract-plugin
export default {"cls1":"PaperSelector-cls1_zMa","cls2":"PaperSelector-cls2__bg PaperSelector-cls1_zMa"};